export enum Keys {
  //auth
  INSERT_MOBILE_MUT = 'insert_mobile_mut',
  VERIFY_CODE_MUT = 'verify_code_mut',
  LOGOUT_MUT = 'logout_mut',

  // user
  USER_QRY = 'user_qry',
  PROVINCES_QRY = 'provinces_qry',
  CITIES_QRY = 'cities_qry',
  EDIT_USER_MUT = 'edit_user_mut',

  // home
  HOME_QRY = 'home_qry',
  VERSION_QRY = 'version_qry',
  ABOUT_US_QRY = 'about_us_qry',
  CONTACT_US_QRY = 'contact_us_qry',

  // category
  CATEGORY_QRY = 'category_qry',

  // product
  PRODUCTS_QRY = 'products_qry',
  FAVORITE_MUT = 'favorite_qry',

  // cart
  CART_QRY = 'cart_qry',
  CHANGE_CART_ITEM_MUT = 'change_cart_item_mut',
  CART_COMPLETION_MUT = 'cart_completion_mut',
  REMOVE_CART_ITEM_MUT = 'remove_cart_item_mut',
  REMOVE_CART_MUT = 'remove_cart_mut',

  // factor
  FACTORS_QRY = 'factors_qry',
  FACTOR_QRY = 'factor_qry',
}
